import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App';
import { DataProvider } from './contexts/DataContext'; // <-- Новый импорт
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <DataProvider> {/* <-- Обертка приложения */}
      <App />
    </DataProvider>
    <Analytics />
  </React.StrictMode>
);
